import { post } from "@common/api/apiShared";
import { useDotLegalMutation, useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { useParams } from "react-router";
import { PublicPolicyAcknowledgementViewModel } from "./PublicPolicyAcknowledgement.types";

export function usePublicPolicyAcknowledgement() {
    const { acknowledgementId } = useParams<{ acknowledgementId: string }>();
    const url = `/public-policy-acknowledgement/${acknowledgementId}`;

    const { data, isLoading } = useDotLegalQuery<PublicPolicyAcknowledgementViewModel>(url, { refetchOnWindowFocus: false });

    const acknowledgeMutation = useDotLegalMutation(() => post<{}>(url, {}));

    return {
        data,
        isLoading,
        acknowledge: () => acknowledgeMutation.mutateAsync(),
        isAcknowledging: acknowledgeMutation.isLoading,
        hasAcknowledged: acknowledgeMutation.data !== undefined,
    };
}
